import { NgModule } from "@angular/core";

import { AvatarComponent } from "./avatar.component";

@NgModule({
  imports: [AvatarComponent],
  exports: [AvatarComponent],
})
export class AvatarModule {}
